import ContentTypeMismatchIcon from "components/partials/icon/content-type-mismatch-icon";

export const getTabViews = (
  hasWarning: boolean,
  isProgramTemplates: boolean,
  hideVersionHistory = false,
) => {
  const tabs = isProgramTemplates
    ? [
        { label: "Preview", value: "Preview" },
        { label: "Version history", value: "Version history" },
      ]
    : [
        { label: "Preview", value: "Preview" },
        {
          label: (
            <div className=" flex items-center gap-1">
              Details
              {hasWarning && <ContentTypeMismatchIcon customClass="size-5" />}
            </div>
          ),
          value: "Details",
        },
        { label: "Version history", value: "Version history" },
      ];

  if (!hideVersionHistory) {
    return tabs;
  }

  return tabs.filter((tab) => tab.value !== "Version history");
};
